import { z } from 'zod';

export const ListarComprasAgilesUiSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  resumen: z.string().nullable(),
  codigo_externo: z.string(),
  codigo_estado: z.number(),
  estado_licitacion: z.string(), // Mapeado desde estado_compra_agil
  fecha_creacion: z.string().nullable(),
  fecha_cierre: z.string().nullable(),
  archivos: z.array(z.object({
    nombre: z.string(),
    url_externa: z.string(),
    path_local: z.string()
  })),
  visto: z.array(z.number()).nullable(),
  postulado: z.boolean().nullable(),
  fecha_postulacion: z.string().nullable(),
  adjudicado: z.boolean().nullable(),
  fecha_adjudicacion: z.string().nullable()
});

export type ListarComprasAgilesUi = z.infer<typeof ListarComprasAgilesUiSchema>; 